// eslint-disable-next-line unused-imports/no-unused-imports
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { app } from './FirebaseService'

export const functions = getFunctions(app)
// connectFunctionsEmulator(functions, 'localhost', 5001)
